import { isStatusCompleted, isStatusFailed, isStatusCancelled } from 'pages/crawler/utils/crawlerStatusUtils';

export const isCompletedStatus = (status?: any): boolean => isStatusCompleted(status);
export const isInactiveStatus = (status?: any): boolean => isStatusCompleted(status) || isStatusFailed(status) || isStatusCancelled(status);
